import { render, staticRenderFns } from "./PSALogo.vue?vue&type=template&id=26ae62a6&"
import script from "./PSALogo.vue?vue&type=script&lang=js&"
export * from "./PSALogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports